const showsOrderTag = (orderId: string) => ({ id: `shows:${orderId}`, type: "Orders" as const });

export default showsOrderTag;
